import { createFormStoreEvents } from '../../create-form-store-events';

export const offshoreOperationalEvents = createFormStoreEvents('offshoreOperationalStore');
